import React, { useRef, useState } from 'react';
import c from 'classnames';

import {
  Button, Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import lottieArrow from '../../assets/lotties/arrow-right/data.json';

import './style.scss';

const ButtonWrapper = ({ children, onClick, href, type, ...props }) => {
  const [mousePositionRelativeX, setMousePositionRelativeX] = useState(0);
  const [mousePositionRelativeY, setMousePositionRelativeY] = useState(0);
  const [hover, setHover] = useState(false);

  const buttonRef = useRef();

  const lottieAnimation = useRef(null);
  const TYPE_PRIMARY = 'primary';
  const TYPE_SECONDARY = 'secondary';
  const TYPE_INVERTED = 'inverted';
  const TYPE_TERTIARY = 'tertiary';

  const buttonClasses = c({
    'Button--primary': type === TYPE_PRIMARY,
    'Button--secondary': type === TYPE_SECONDARY,
    'Button--inverted': type === TYPE_INVERTED,
    'Button--tertiary': type === TYPE_TERTIARY,
  });

  const onMouseEnterArrow = (e) => {
    lottieAnimation.current.play();
  };

  const setMousePosition = (event) => {
    const bounds = event.target.getBoundingClientRect();
    setMousePositionRelativeX(event.clientX - bounds.left);
    setMousePositionRelativeY(event.clientY - bounds.top);
  };

  const onMouseEnter = (event) => {
    setMousePosition(event);
    setHover(true);
  };

  const onMouseLeave = (event) => {
    setMousePosition(event);
    setHover(false);
  };


  ((url) => {
    if (/^internal:/.test(url)) {
      href = href.replace(/^internal:/, '');
      return true;
    }

    return false;
  })(href);

  ((url) => {
    if (/^entity:/.test(url)) {
      href = href.replace(/^entity:/, '');
      return true;
    }

    return false;
  })(href);

  switch (type) {
    case TYPE_TERTIARY:
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Button {...props} className={buttonClasses} href={href} onClick={onClick} onMouseEnter={onMouseEnterArrow} primary={false}>
            <div>
              {children}
            </div>
            <Lottie
              id={`button__arrow-${Math.floor(Math.random() * (1000 - 2 + 1) + 2)}`}
              className="Button__lottie"
              data={lottieArrow}
              ref={lottieAnimation}
              loop={false}
              autoPlay={false}
              startPosition={0}
              pauseOnClick={false}
              onInit={(instance) => {
                instance.addEventListener('complete', () => {
                  instance.goToAndStop(0);
                });
              }}
            />
          </Button>
        </>
      );

    case TYPE_PRIMARY:
    case TYPE_SECONDARY:
    default:
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Button
            forwardRef={buttonRef}
            className={buttonClasses}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            primary={false}
            href={href}
            {...props}
          >
            <div
              className="Button__circle"
              style={{
                left: `${mousePositionRelativeX}px`,
                top: `${mousePositionRelativeY}px`,
                transform: `${hover ? 'scale(500)' : 'scale(1)'}`,
              }}
            />

            <div className="Button__inner">
              {children}
            </div>
          </Button>
        </>
      );
  }
};

export default ButtonWrapper;
